import { getMarketCode } from '../../utilities/domain/domainConstants';
import Config from '../../Config';
import { isNullOrEmpty } from '../StringHelpers/StringHelpers';

export const LogoType = {
  MainLogo: 'MainLogo',
  SiteLogo: 'SiteLogo',
};

export const LogoHelper = {
  getLogo: (logoType) => {
    var logoUrl = '';
    if (logoType === LogoType.SiteLogo && !isNullOrEmpty(window.Config.siteLogo)) {
      logoUrl =  window.Config.siteLogo?.url;
    }
    if (logoType === LogoType.MainLogo && !isNullOrEmpty(window.Config.mainLogo)) {
      logoUrl =  window.Config.mainLogo?.url;
    }

    if (logoUrl) {
      return  Config.epiBaseUrl + logoUrl;
    }

    const marketCode = getMarketCode()?.toLowerCase();

    if (logoType === LogoType.MainLogo) {
      return require(`./logo/main-icon_${marketCode}.svg`);
    }
    if (logoType === LogoType.SiteLogo) {
      return require(`./logo/logo_${marketCode}.svg`);
    }
    return '';
  },
};
